import { ImageDecoding, ImageLoading, ImageSourceVM } from '@jtnews/shared/images';

const PERSONAL_SELECTION_TYPE = 'personal_selection';

type RecordId = number;

export enum TypeRecord {
  Commercial = 'Рекламный',
  Editorial = 'Редакционный'
}

export type NotLazyBlockVM<T, D, P, M> = {
  type: T;
  isLazy: false;
  params: P;
  meta: M;
  reachGoal: {
    general: string[];
    view: string[];
  };
  data: D;
};

export type PersonalSelectionItemVM = {
  id: RecordId;
  header: string;
  url: string;
  comments: {
    count: number;
    url: string;
    isAllowed: boolean;
  };
  image: {
    src: string;
    sources: ImageSourceVM[];
    loading?: ImageLoading;
    decoding?: ImageDecoding;
  };
  viewsCount: number;
  type: TypeRecord.Commercial | TypeRecord.Editorial;
  formats: {
    id: string;
    text: string;
    url: string;
  }[];
  themes: {
    id: string;
    text: string;
    url: string;
  }[];
  rubrics: {
    id: string;
    text: string;
    url: string;
  }[];
};

export type PersonalSelectionBlock = NotLazyBlockVM<
  typeof PERSONAL_SELECTION_TYPE,
  PersonalSelectionItemVM[],
  null,
  null
>;
